import React from "react";

function AccountDashboard() {
  return (
    <>
      <div className="card p-5 text-center">
        <h3 className="font-bold">Account dashboard </h3>
      </div>
    </>
  );
}

export default AccountDashboard;
